import { IPublicRestaurant, Label, MessageType, ReservationStatus } from '@localina/core';
import { ClockIcon, DoneIcon } from '@localina/icons';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Message, ReservationSummaryCard } from '../../../components';
import { IApplicationStore } from '../../../interfaces';

interface IProps extends IStoreProps {
    restaurant: IPublicRestaurant;
}

const Done: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const isRequested = props.bookingResponse?.status === ReservationStatus.APPROVAL_PENDING;
    const isApproved = props.bookingResponse?.status === ReservationStatus.APPROVED;

    return (
        <>
            <div className="widget-done-status">
                {(isApproved || isRequested) && (
                    <span className={`widget-done-status__icon ${isRequested ? 'requested' : 'approved'}`}>
                        {isRequested ? <ClockIcon /> : <DoneIcon />}
                    </span>
                )}
                <Label type="title" value={t('reservation.done.title')} variant="h5" align="center" />
                {isRequested && (
                    <Label
                        type={'text'}
                        align="center"
                        value={
                            <Trans
                                t={t}
                                i18nKey={'reservation.done.reservationRequestedDescription'}
                                values={{ phoneNumber: props.restaurant.phoneNumber }}
                                components={[
                                    <a key={'restaurant-phone-number'} href={`tel:${props.restaurant.phoneNumber}`} />,
                                ]}
                            />
                        }
                        extraClassName={'reservation-requested'}
                    />
                )}
                {isApproved && <Label type="text" value={t('reservation.done.description')} align="center" />}
            </div>
            <ReservationSummaryCard />
            <Message restaurant={props.restaurant} type={MessageType.GOODBYE} title={t('reservation.welcome.title')} />
            <div className="grow" />
            <Label type="title" value={t('reservation.done.endline')} variant="h5" align="center" />
        </>
    );
};

interface IStoreProps {
    bookingResponse: IApplicationStore['reservation']['bookingResponse'];
}

const mapStateToProps = (state: IApplicationStore): IStoreProps => ({
    bookingResponse: state.reservation.bookingResponse,
});
export default connect(mapStateToProps)(Done);
